import Http from '../lib/http'
import { normalizeUserPayload } from '../utils/userStorage'

export async function fetchCurrentUser() {
  const response = await Http.get('api/my-user')
  const payload = response?.data
  if (!payload) return null
  return normalizeUserPayload(payload) || normalizeUserPayload(payload.data) || null
}
